import { Component, OnInit } from '@angular/core';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { LinkAboutBgtComponent } from '../shared/link-about-bgt/link-about-bgt.component';
import { LinkDownloadBgtComponent } from '../shared/link-download-bgt/link-download-bgt.component';
import { LinkBgtWfsComponent } from '../shared/link-bgt-wfs/link-bgt-wfs.component';
import { CallToActionComponent } from '../shared/call-to-action/call-to-action.component';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, RouterLink, LinkAboutBgtComponent, LinkDownloadBgtComponent, LinkBgtWfsComponent, CallToActionComponent]
})
export class FaqComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
